




























import { loading, loadingCatch } from "@root/lib/decorator";
import {
  Component,
  Emit,
  Model,
  Prop,
  PropSync,
  Vue,
  Watch
} from "vue-property-decorator";
import {
  callLinkedFn,
  debounceFactory,
  clearEmptyAttr
} from "@root/utiles/common";
const defaultPagination = () => ({ pageNum: 1, pageSize: 10, total: 0 });

/**
 * $emit('change', bindValue)
 * $emit('select', object)
 * $emit('list-change',  { total = 0, list = [] })
 */
@Component
@loading()
export default class RemoteSelect extends Vue {
  @Prop({ type: String, default: "请输入关键词" })
  private placeholder: string;

  @Prop({ default: () => [], type: [String, Array] }) value: [
    String,
    Array<any>
  ];
  // @PropSync("optionData", { type: [Object, Array], default: () => [] })

  @Prop({ type: Boolean, default: true })
  private clearable: boolean;

  @Prop({ type: Boolean, default: false })
  private disabled: boolean;

  @Prop({ type: Boolean, default: false })
  private multiple: boolean;

  @Prop({ type: Function, default: () => {} })
  private remoteMethod: Function;

  @Prop({ type: Object, default: () => ({}) })
  options!: any; // 字段匹配等配置

  @Prop({ type: Boolean, default: false })
  private paging: boolean; // 是否分页

  // @Prop({ type: Boolean, default: () => defaultPagination() })
  private pagination: any = defaultPagination(); // 分页参数

  @Prop({ type: Boolean, default: true })
  isItem: boolean; // 展示label+value为 label

  // @Model("change") bindValue!: any;

  private loading = false;
  private searchKey = "";
  private optionDataSync: any = [];
  private debounceSearch = null;
  private debounceLoadMore = null;

  private bindValue = null; // watch bindValue
  private oldSearchKey = null;
  private allOptionDataList = [];

  @Watch("value", { immediate: true }) handleModelChange(val) {
    const hasExistVal = this.optionDataSync.some(
      el => el && el[this.getOptions.value]
    );
    // 找出没有搜到的值，进行接口搜索。搜索次数不能大于一定值
    if (!hasExistVal) {
      this.search(val);
    }
    this.bindValue = val;
  }

  get getOptions() {
    const defaultOptions = { label: "label", value: "value" };
    return {
      ...defaultOptions,
      ...this.options
    };
  }

  get listData() {
    const { label, value } = this.getOptions;
    if (Array.isArray(this.optionDataSync)) {
      return this.optionDataSync.map(item => ({
        label: item[label],
        value: item[value]
      }));
    } else {
      return Object.keys(this.optionDataSync).map(key => ({
        [label]: key,
        [value]: this.optionDataSync[key]
      }));
    }
  }

  created() {
    console.log("crteate removete select");
    // debounce有问题
    this.debounceSearch = debounceFactory(this.search, 300);
    this.debounceLoadMore = debounceFactory(this.loadMore, 300);
  }

  change(val) {
    // change reset value for chanege data
    this.emitChangeVal(val);
    // 设置
    try {
      const { searchKey } = this;
      if (typeof searchKey === "string" && searchKey) {
        setTimeout(() => {
          // 搜索到的单个数据添加
          this.optionDataSync = this.allOptionDataList;
          this.setSelected();
          console.log(this.optionDataSync);
        }, 500);
      }
    } catch (error) {
      console.warn(`[CustomRemoteSelect] setSelected error`);
    }
    console.log(this.allOptionDataList, "allOptionDataList");
  }

  emitChangeVal(val) {
    const { multiple } = this;
    let selectVal = null;
    if (multiple && Array.isArray(val)) {
      selectVal = this.allOptionDataList.filter(el =>
        val.includes(el[this.getOptions.value])
      );
      if (val.length !== this.optionDataSync) {
        this.optionDataSync = selectVal;
      }
    } else {
      selectVal = this.optionDataSync.find(
        o => o[this.getOptions.value] === val
      );
    }
    this.bindValue = val;
    this.$emit("select", selectVal);
    this.$emit("change", val);
  }
  search(searchKey?: string) {
    searchKey = typeof searchKey === "string" ? searchKey : "";
    // 不会多次请求数据
    if (searchKey === this.oldSearchKey) {
      this.optionDataSync = this.allOptionDataList;
    } else {
      this.oldSearchKey = searchKey;
      this.searchKey = searchKey;
      this.clearData();
      this.execute();
    }
  }
  handleRemoveTag() {
    // TODO: 优化这种赋值方法
    this.optionDataSync = this.allOptionDataList;
  }

  fItemStr({ label, value }) {
    let str = "";
    if (value && typeof value !== "undefined") {
      str = `${label} _ ${value}`;
    } else {
      str = label;
    }
    return str;
  }

  // 加载下一页
  async loadMore() {
    if (!this.paging) return false;
    if (
      this.pagination.total !== 0 &&
      this.pagination.total <= this.optionDataSync.length
    ) {
      return;
    }
    this.pagination.pageNum++;
    this.execute();
  }

  clearData() {
    this.pagination = defaultPagination();
    this.optionDataSync = [];
  }

  async execute() {
    try {
      await callLinkedFn(
        this.executeBefore.bind(this),
        this.executeRemoteMethod.bind(this),
        this.executeAfter.bind(this)
      );
    } finally {
      this.loading = false;
    }
  }

  async executeRemoteMethod() {
    return await this.remoteMethod(
      clearEmptyAttr({
        searchKey: this.searchKey || "",
        pageInput: this.paging ? this.pagination : null
      })
    );
  }

  executeBefore() {
    if (this.pagination.pageNum === 1) {
      this.loading = true;
    }
  }

  setSelected() {
    this.$nextTick(() => {
      (this.$refs.customRemoteSelect as any).setSelected();
    });
  }

  @Emit("list-change")
  executeAfter(data: any) {
    const getUniqueItem = list => {
      const optionValues = this.allOptionDataList.map(
        el => el && el[this.getOptions.value]
      );
      const uniqueList = list.filter(
        el => !optionValues.includes(el && el[this.getOptions.value])
      );
      return uniqueList;
    };

    const { total = 0, list = [] } = data || {};
    if (this.pagination.pageNum === 1) {
      this.optionDataSync = list;
    } else {
      this.optionDataSync.push(...list);
    }
    const unDatas = getUniqueItem(list);
    this.allOptionDataList.push(...unDatas);

    this.pagination.total = total;
    return data;
  }

  beforeDestroy() {
    this.allOptionDataList = [];
  }
}
